import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TravelRequestEdit } from '@/module/Travel/Request/TravelRequestEdit';
import { getTravelRequestOptions } from '@/module/Travel/Request/model/TravelRequestQuery';

import { NoContentPlaceholder } from '@/core/components';

import { RoleType, useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/travel/_travel/requests/$requestId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const { currentRole } = useCurrentUser();

  if (currentRole !== RoleType.AUTHOR) {
    return <NoContentPlaceholder title={t('travel.requests.noAccess')} />;
  }

  return <EditRoute />;
}

function EditRoute() {
  const { requestId } = Route.useParams();
  const { data: request } = useSuspenseQuery(getTravelRequestOptions(requestId));

  return <TravelRequestEdit request={request} />;
}
